module.exports = __webpack_public_path__ + "static/media/email-verify.5a97b46d.png";